<ph-list-row *ngFor="let file of files; trackBy: trackById"
             plain
             [heading]="file.fileName"
             [attr.meta]="meta(file)">
    <ph-file-icon slot="leading" [name]="file.fileName"></ph-file-icon>
    <ph-tag *ngIf="file.fromEmail" slot="actions" variant="gray" icon="envelope-simple">Email attachment</ph-tag>
    <ph-compact-button *ngIf="file.viewUrl" slot="actions" variant="ghost" size="large" icon="eye"
                       [attr.aria-label]="'View ' + file.fileName"
                       (click)="open(file.viewUrl)"></ph-compact-button>
    <ph-compact-button *ngIf="file.downloadUrl" slot="actions" variant="ghost" size="large" icon="download-simple"
                       [attr.aria-label]="'Download ' + file.fileName"
                       (click)="open(file.downloadUrl)"></ph-compact-button>
    <ph-compact-button *ngIf="deletable" slot="actions" variant="ghost" size="large" destructive icon="trash"
                       [attr.aria-label]="'Delete ' + file.fileName"
                       [disabled]="deletingId !== null"
                       (click)="delete.emit(file)"></ph-compact-button>
</ph-list-row>
